import Box from "ds/components/Box";
import Code from "ds/components/Code";
import TextEllipsis from "ds/components/TextEllipsis";

import { COMPUTED_VALUE, EMPTY_VALUE, WRITE_ONLY_VALUE } from "../../constants";
import { VariableCellComponentProps } from "./types";

const ValueCell = ({ variable }: VariableCellComponentProps) => {
  let displayValue: string;
  if (variable.runtime) {
    displayValue = COMPUTED_VALUE;
  } else if (variable.writeOnly) {
    displayValue = WRITE_ONLY_VALUE;
  } else if (!variable.value) {
    displayValue = EMPTY_VALUE;
  } else {
    displayValue = variable.value?.replace(/ /g, "\u00a0");
  }

  return (
    <Box>
      <TextEllipsis tooltip={displayValue} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Code {...props} whiteSpaceVisible>
            {displayValue}
          </Code>
        )}
      </TextEllipsis>
    </Box>
  );
};

export default ValueCell;
